import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import { requestDeviceLogRequest, clearRedux } from 'Redux/actions';

const VIDFLEET_ERROR_CODES = {
    23: "common_authentication_failed",
    24: "",
    200: "common_camera_password_error",
    201: "common_camera_operation_failed",
    202: "common_camera_does_not_exist",
    204: "common_sync_camera_error",
    209: "common_camera_does_not_exist",
}

const RequestDeviceLog = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef(null);
    const { device } = props
    const [request, setRequest] = useState("");

    const { loading, result, openModal } = useSelector(state => state.requestDeviceLogRedux)

    const closeModal = () => {
        dispatch(clearRedux("REQUEST_DEVICE_LOG"));
        setRequest("");
    }

    const requestLog = () => {
        dispatch(requestDeviceLogRequest({ esn: device.esn, id: device?.id, request }))
    }

    useEffect(() => {
        if (result && !result?.error) {
            if (result?.result?.logID) {
                NotificationManager.success(
                    messages['request_device_log_request_log_command_has_been_sent'],
                    messages['request_device_log_title'],
                    3000
                );
                closeModal();
            } else {
                NotificationManager.error(
                    messages['reboot_device_sending_command_not_accepted'],
                    messages['request_device_log_title'],
                    3000
                );
            }
        } else if (result?.error) {
            let message = messages['request_device_log_error_sending_the_command'];
            if (result.error && result.error.code) {
                let messageKey = VIDFLEET_ERROR_CODES[result.error.code]
                if (!messageKey && messageKey !== "") {
                    message = messages[messageKey];
                } else {
                    message = result.error.msg
                }
            }
            //Error message
            NotificationManager.error(
                message,
                messages['request_device_log_title'],
                3000
            );
            closeModal();
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['request_device_log_title']}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => requestLog()}
                    >
                        <label style={{ marginBottom: 5 }}>
                            {messages['request_device_log_label']}
                        </label>
                        <div style={{ height: 400 }}>
                            <Input
                                type="textarea"
                                value={request}
                                onChange={(value) => setRequest(value)}
                                required
                                requiredMessage={messages['required_field']}
                                minLength={5}
                                minLengthMessage={messages['request_device_log_min_characters']}
                            />
                        </div>
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => formRef?.current?.submit()}
                >
                    {messages['request_device_log_request_log']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default RequestDeviceLog;